import { useEffect, useState } from "react";

/**
 * Tracks whether the document is currently in browser fullscreen mode
 * (requestFullscreen / Esc).
 *
 * Used by App.tsx to hide chrome (Header, etc) while a game owns the
 * viewport — Pong's "Find Opponent" and Snake's "Enter server" both
 * call document.documentElement.requestFullscreen(). The user can leave
 * at any time with Esc, and the listener flips us back to windowed.
 */
export function useIsFullscreen(): boolean {
  const [fs, setFs] = useState<boolean>(() =>
    typeof document !== "undefined" ? !!document.fullscreenElement : false,
  );
  useEffect(() => {
    const update = () => setFs(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", update);
    // Safari prefixes the event name on older versions
    document.addEventListener("webkitfullscreenchange", update as EventListener);
    update();
    return () => {
      document.removeEventListener("fullscreenchange", update);
      document.removeEventListener("webkitfullscreenchange", update as EventListener);
    };
  }, []);
  return fs;
}
